// "Piloto automático" da demonstração: preenche cadastro e onboarding sozinho, digitando na
// frente do cliente, até chegar no painel da arena. Ativado por ?auto=1 na URL.
export const AUTOPILOT_PARAM = 'auto';

export class AutopilotCancelled extends Error {
  constructor() {
    super('Simulação interrompida');
    this.name = 'AutopilotCancelled';
  }
}

export function pause(ms: number, signal: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal.aborted) return reject(new AutopilotCancelled());
    const timer = window.setTimeout(resolve, ms);
    signal.addEventListener(
      'abort',
      () => {
        window.clearTimeout(timer);
        reject(new AutopilotCancelled());
      },
      { once: true }
    );
  });
}

/** Digita `text` caractere a caractere, focando o campo `fieldName` para o cliente acompanhar. */
export async function typeInto(
  setValue: (value: string) => void,
  text: string,
  signal: AbortSignal,
  fieldName?: string,
  speedMs = 28
): Promise<void> {
  if (fieldName) {
    const field = document.querySelector<HTMLElement>(`[name="${fieldName}"]`);
    field?.focus({ preventScroll: true });
    field?.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  for (let index = 1; index <= text.length; index++) {
    setValue(text.slice(0, index));
    await pause(speedMs, signal);
  }
}

// Dados de exemplo usados na simulação (fictícios).
export const DEMO_OWNER = {
  name: 'Carlos Mendes',
  email: 'carlos@arenasolnascente.com.br',
  phoneDigits: '85988887777',
  password: 'SolNascente@2026',
};

export const DEMO_ARENA = {
  arenaName: 'Arena Sol Nascente',
  unitName: 'Unidade Cumbuco',
  address: 'Av. dos Coqueiros, 120 - Cumbuco',
  extraSports: ['Futevôlei'],
  courts: [
    { name: 'Quadra Central', sportIds: ['Beach Tennis'], pricePerHour: 90 },
    { name: 'Quadra Pôr do Sol', sportIds: ['Beach Tennis', 'Futevôlei'], pricePerHour: 80 },
    { name: 'Quadra Coberta', sportIds: ['Beach Tennis'], pricePerHour: 120 },
  ],
  team: [
    { name: 'Bruno Lima', role: 'recepcao' as const },
    { name: 'Camila Rocha', role: 'instrutor' as const },
  ],
  planId: 'profissional',
};
